(window as any).googleConsentListeners = [];

(window as any).addConsentListener = (callback) => {
    (window as any).googleConsentListeners.push(callback);
};

(window as any).googleConsentListeners.push((data => console.log(data)));